import { useParams } from 'react-router-dom';

const useMatch = () => {
  const params = useParams();
  return { params };
};

export default useMatch;